/* @ngInject */

export default class RegisterCtrl {
	constructor(
		$scope,
		$state,
		Utility,
		$timeout,
		$rootScope,
		RegisterService,
		NotificationService,
		LocalStorageService,
		CountriesUtilService,
		$location
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.$location = $location;

		this.Utility = Utility;
		this.RegisterService = RegisterService;
		this.NotificationService = NotificationService;
		this.LocalStorageService = LocalStorageService;
		this.CountriesUtilService = CountriesUtilService;

		this.init();
		this.activate();
	}

    activate() {
        let isConfirmed = false;

		if (
			this.$state.params &&
			this.$state.params.hasOwnProperty('email') &&
			this.$state.params.hasOwnProperty('token')
		) {
			this.LocalStorageService.clear();
            const { email, token } = this.$state.params;
            if (email && token) {

                this.currentStep = 5;
                this.activationStatus = 'busy';
 
				this.RegisterService.confirmEmail(email, token).then(
                    (results) => {
                        this.currentStep = 5;
                        isConfirmed = true;
						this.activationStatus = 'done';
						this.$rootScope.$digest();

					},
                    (err) => {
						this.activationStatus = 'error';
						this.$rootScope.$digest();
						
					}
				);

				
				
				this.LocalStorageService.clearAll();
				
            }

        }
        this.CountriesUtilService.load().then(
            (results) => { },
            (err) => {
                console.error(err);
            }
        );
        if (isConfirmed) {
            this.$rootScope.$broadcast('user-logged-out');
        }
	}

	init() {
		this.selectedCountryCode = '+27';
		this.style = {
			width: '25%'
		};

		this.showResendButton = false;

		this.email = '';
		this.name = '';
		this.surname = '';
		this.cellphone = '';
		this.password = '';
		this.confirmPassword = '';

		this.progress = 25;
		this.currentStep = 0;
		this.error = '';

		this.activationStatus = 'busy';
		this.mobileRegStatus = 'done';

		this.isBusy = false;
	}

	gotoBack() {
		this.currentStep--;
		this.updateProgress();
	}

	gotoNext() {
		this._switchIsBusy(false);
		this.currentStep++;
		this.updateProgress();
	}

	async submit(evt) {
		try {
			let errMsg = '';
			if (this.currentStep === 0) {
				this._switchIsBusy(true);
				this.showResendButton = false;

				const userDoesNotExists = await this.RegisterService.checkIfUserExists(this.email);
				if (!this.RegisterService.userAlreadyExists) {
					const results = await this.RegisterService.validateEmail(this.email);
					this.gotoNext();
				} else {
					if (!this.RegisterService.isUserConfirmed) {
						errMsg = `User with email(${this
							.email}) is already registered but not confirmed.\n If you would like to resend the confirmation email click below, else contact Pretor.`;
						this.showResendButton = true;
					} else {
						errMsg = `User with email(${this
							.email}) is already registered with Pretor.\n If you forgot your password, request for a password reset, else contact Pretor.`;
					}
				}
			} else if (this.currentStep === 2) {
				let errMsg = '';
				this._switchIsBusy(true);
				const mobileNumber = this.getInternationalMobileNumber();

				const results = await this.RegisterService.registerUser(
					this.email,
					this.name,
					this.surname,
					mobileNumber,
					this.password
				);
				this.gotoNext();
			}

			this.error = errMsg;
		} catch (error) {
			this.showError(error);
		} finally {
			this._switchIsBusy(false);
		}
	}

	async resend() {
		let errMsg = '';

		try {
			const results = await this.RegisterService.resend(this.email);
			errMsg = '';
			this.NotificationService.success('EMAIL RESENT.');
		} catch (error) {
			errMsg = `Error while re-sending your details, please try again or contact Pretor if the error persists.`;
			console.error(error);
		} finally {
			this._switchIsBusy(false);
			this.showError(errMsg);
		}
	}

	updateProgress() {
		this.progress = 25 * (this.currentStep + 1);

		this.style = {
			width: `${this.progress}%`
		};
	}

	showError(msg) {
		this.error = msg;
	}

	getInternationalMobileNumber() {
		return `${this.selectedCountryCode}${this.cellphone}`;
	}

	_switchIsBusy(flag) {
		this.$timeout(() => {
			this.isBusy = flag;
		});
	}
}
